import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../Components/Button";
import CameraComponent from "../Components/CameraComponent";
import Input from "../Components/Input";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createKeyEntry,
  getKeysData,
  updateKeyManagement,
} from "./mutations/keyManagement";
import { formatTime, formatDate } from "../../utils/formatDate";
import { handleToastMsg } from "../Components/Toast";
import Loader from "../Components/Loader";
import CustomDivider from "../Components/CustomDivider"

const Outline = styled(Grid)`
  border: 1px solid #000;
  width: 200px;
  height: 100px;
  text-align: center;
`;

function KeyManagement() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  const [stepper, setStepper] = useState("SCAN");
  const [capturedImage, setCapturedImage] = useState(null);
  const [barcodeValue, setBarcodeValue] = useState("");

  const [imageBoxVisible, setImageBoxVisible] = useState(true); // Track the ImageBox visibility
  const [mediaStream, setMediaStream] = useState(null);
  const [showCapture, setShowCapture] = useState(false);

  const queryClient = useQueryClient();
  const { mutate, isLoading: creationLoader } = useMutation(createKeyEntry);
  const { mutate: updateMutate, isLoading: updateLoader } =
    useMutation(updateKeyManagement);

  const { data } = useQuery(
    "get-keys-data",
    () => getKeysData(),
    {
      refetchOnMount: true,
      select: (res) => res.keyQueue,
    },
    {}
  );

  const handleKeySubmit = () => {
    const payload = {
      person_image: capturedImage,
      key_type: barcodeValue,
    };

    mutate(payload, {
      onSuccess: (res) => {
        console.log(res);
        setBarcodeValue("");
        queryClient.invalidateQueries("get-keys-data");
        handleToastMsg("Data added successfully", "success");
        setStepper("QUEUE");
      },
    });
  };

  const updateKeystatus = (id) => {
    updateMutate(id, {
      onSuccess: () => {
        queryClient.invalidateQueries("get-keys-data");
        handleToastMsg("Key removed from queue successfully", "success");
      },
    });
  };

  if (updateLoader) return <Loader />;

  console.log({ data });

  return (
    <Grid container justifyContent={"center"}>
      <Grid
        item
        container
        textAlign={"center"}
        justifyContent="center"
        xs={12}
        py={1}
      >
        <h4>Key Management / சாவி மேலாண்மை</h4>
        <CustomDivider />
      </Grid>
      {stepper && stepper === "QUEUE" && (
        <Grid item container justifyContent={"center"}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Date / தேதி</TableCell>
                <TableCell> type / வகை</TableCell>
                <TableCell align="center"> Person / நபர்</TableCell>
                <TableCell align="center"> Key type</TableCell>
                <TableCell align="center">
                  {" "}
                  Taken time / நேரம் எடுத்தது
                </TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length > 0 ? (
                data.map((row) => (
                  <TableRow
                    key={row.referenceNo}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{formatDate(row.date)}</TableCell>
                    <TableCell component="th" scope="row">
                      {row.keyType}
                    </TableCell>
                    <TableCell component="th" scope="row" align="right">
                      <img
                        src={row.personImage}
                        alt="img"
                        height={150}
                        width={150}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.keyType}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatTime(row.takenTime)}
                    </TableCell>
                    <TableCell align="right">
                      <CustomButton onClick={() => updateKeystatus(row.id)}>
                        Out / வெளியே
                      </CustomButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <h4>No data found</h4>
              )}
            </TableBody>
          </Table>
        </Grid>
      )}

      {stepper && stepper === "SCAN" && (
        <Grid item container xs={12} rowGap={2}>
          <Grid
            item
            container
            justifyContent={"center"}
            alignItems={"center"}
            direction={"column"}
            rowGap={4}
          >
            <Grid item>
              <Outline
                item
                contianer
                alignItems={"center"}
                container
                direction={"row"}
                justifyContent={"center"}
                px={2}
              >
                <h4>Scan</h4>
                <Input
                  type="text"
                  value={barcodeValue}
                  onChange={(e) => setBarcodeValue(e.target.value)}
                  style={{ padding: "8px 16px" }}
                />
              </Outline>
            </Grid>
            <Grid item>
              <CameraComponent
                capturedImage={capturedImage}
                setCapturedImage={setCapturedImage}
                setImageBoxVisible={setImageBoxVisible}
                imageBoxVisible={imageBoxVisible}
                setMediaStream={setMediaStream}
                mediaStream={mediaStream}
                showCapture={showCapture}
                setShowCapture={setShowCapture}
              />
            </Grid>

            <Grid item>
              <CustomButton
                onClick={handleKeySubmit}
                isLoading={creationLoader}
              >
                Submit
              </CustomButton>
            </Grid>
          </Grid>
          <Grid
            container
            item
            p={1}
            justifyContent={isMobile ? "center" : "flex-end"}
          >
            <CustomButton onClick={() => setStepper("QUEUE")}>
              View Queue / காட்சி வரிசை
            </CustomButton>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default KeyManagement;
